import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { OnDemandDriversComponent } from './on-demand-drivers.component';

const routes: Routes = [{
  path: 'ondemand-drivers',
  component: OnDemandDriversComponent,
  data: {
    title: 'On Demand Drivers'
  }
}];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers: []
})
export class OnDemandDriversRoutingModule { }



// WEBPACK FOOTER //
// ./src/app/pages/on-demand-drivers/on-demand-drivers-routing.module.ts